export default {
  'profileaccounts.accountsmanagement': 'مدیریت حساب های بانکی',
  'profileaccounts.bankname': 'نام بانک',
  'profileaccounts.branchname': 'نام شعبه',
  'profileaccounts.accountno': 'شماره حساب',
  'profileaccounts.cardno': 'شماره کارت',
  'profileaccounts.shebano': 'شماره شبا',
  'profileaccounts.ismain': 'حساب پیش فرض',
  'profileaccounts.register': 'ثبت',
  'profileaccounts.delete': 'حذف',
  'profileaccounts.deleteaccount': 'حذف حساب بانکی',
  'proprofileaccountsfile.cancel': 'لغو',
  'profileaccounts.deleteconfirmation': 'آیا از حذف حساب بانکی مطمئن هستید ؟',
  'profileaccounts.accountadd': 'حساب بانکی مورد نظر با موفقیت ثبت گردید',
  'profileaccounts.tryagain': 'لطفا مجددا تلاش نمایید',
  'profileaccounts.enterinfo': 'لطفا اطلاعات حساب را وارد نمایید',
  'profileaccounts.addaccount': 'افزودن حساب بانکی',
  'profileaccounts.cardno-account': 'شماره کارت / حساب',
  'profileaccounts.accountsmanage': 'مدیریت حساب ها',
  'profileaccounts.Textaccountsmanage':
    'از طریق فرم زیر می توانید حساب مورد نظر را ثبت نمایید .',
};
